module.exports = __webpack_public_path__ + "static/1-6a1a1887e8b5d11930c8a06b39379b2d.png";